import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Link from '../../components/link/link';

import styles from './venue-event-list.module.scss';

const VenueEventList = ({ events = [], venue, filterSundownSocial = false }) => {
  const today = moment();

  const isFutureOrOngoing = (start, end) => {
    const startDate = start ? moment(start) : null;
    const endDate = end ? moment(end) : null;

    if (endDate) {
      return endDate.isSameOrAfter(today, 'day');
    }
    if (startDate) {
      return startDate.isSameOrAfter(today, 'day');
    }
    return false;
  };

  const filteredEvents = events.filter((event) => {
    if (filterSundownSocial) {
      // Only include events in the "Sundown Social" series
      if (
        event.relationships?.field_series?.name !== 'Sundown Social' ||
        !event.date
      ) {
        return false;
      }

      const start = event.date.start;
      const end = event.date.end;
      return isFutureOrOngoing(start, end);
    } else {
      // Default date filtering using field_date
      if (event.field_date) {
        const start = event.field_date.value;
        const end = event.field_date.end_value;
        return isFutureOrOngoing(start, end);
      }
    }

    return false;
  });

  if (filteredEvents.length > 0) {
    return (
      <div className={styles.eventListContainer}>
        <h2>Upcoming Events {!filterSundownSocial && ( `at ${venue}`)}</h2>
        {filteredEvents.map((event) => {
          const isAlt = filterSundownSocial && event.date;
          const startDate = isAlt ? event.date.start : event.field_date?.value;
          const endDate = isAlt ? event.date.end : event.field_date?.end_value;
          const sameDay = startDate === endDate;

          const startMoment = moment(startDate);
          
          const formattedStartDate = startMoment.format('MMMM D, YYYY');
          const formattedEndDate = moment(endDate).format('MMMM D, YYYY');
          

          return (
            <Link
              key={event.title}
              to={event.path.alias}
              aria-label={`View details about the event: ${event.title}`}
              className={styles.eventLink}
            >
              <div className={styles.eventWrapper}>
              <img
                src={
                  event.field_image?.imageDerivatives?.links?.max_1600_16_9?.href || event.relationships?.field_image?.max_1600_16_9?.childImageSharp?.contentTeaser?.src ||
                  '/images/site-default-image.png'
                }
                alt={event.title || 'Event image'}
                loading="lazy"
              />

                <div className={styles.contentWrapper}>
                  <h3>{event.title}</h3>
                  {sameDay ? (
                    <p aria-label={`Event date: ${formattedStartDate}`}>{formattedStartDate}</p>
                  ) : (
                    <p aria-label={`Event dates: ${formattedStartDate} to ${formattedEndDate}`}>
                      {formattedStartDate} - {formattedEndDate}
                    </p>
                  )}
                  {filterSundownSocial && (
                    <p aria-label="summary" className={styles.eventSummary}>
                      {event.body?.summary}
                    </p>
                  )}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    );
  }

  return null;
};

VenueEventList.propTypes = {
  events: PropTypes.array,
  venue: PropTypes.string,
  filterSundownSocial: PropTypes.bool,
};

export default VenueEventList;